import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiGetPostPurchaseData } from "Root/api/apiProfile";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { fetchUserAccountThunk } from "Root/profile/redux/thunkCreators/accountSettings/accountSettingsThunk";
import { LoadRegisteredDietitianThunk } from "Root/profile/redux/thunkCreators/dietitian/registeredDietitian";
import { LoadOrderDetailsThunk } from "Root/profile/redux/thunkCreators/orders/orderDetails";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
import { useLocation } from "react-router";
import posthog from "posthog-js";
import { LoadNextOrderDatesThunk } from "Root/profile/redux/thunkCreators/orders/nextOrderDates";
import { cvgForward } from "reactjs/src/utils/tracking";
const scriptOne = `!function(){var geq=window.geq=window.geq||[];if(geq.initialize) return;if (geq.invoked){if (window.console && console.error) {console.error("GE snippet included twice.");}return;}geq.invoked = true;geq.methods = ["page", "suppress", "trackOrder", "identify", "addToCart", "callBack", "event"];geq.factory = function(method){return function(){var args = Array.prototype.slice.call(arguments);args.unshift(method);geq.push(args);return geq;};};for (var i = 0; i < geq.methods.length; i++) {var key = geq.methods[i];geq[key] = geq.factory(key);}geq.load = function(key){var script = document.createElement("script");script.type = "text/javascript";script.async = true;if (location.href.includes("vge=true")) {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js?v=" + Math.random();} else {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js";}var first = document.getElementsByTagName("script")[0];first.parentNode.insertBefore(script, first);};geq.SNIPPET_VERSION = "1.6.1";
geq.load("350H9NW5");}();`;
function unloadScript(scriptElement) {
    document.head.removeChild(scriptElement);
}
function loadScriptOne() {
    const script = document.createElement("script");
    script.textContent = scriptOne; // Your script text
    script.async = true;
    document.head.appendChild(script);
    return script;
}
function executeScriptTwo({ orderNumber, orderAmount, orderEmail }) {
    // Directly execute the script content
    // Make sure `geq` and its methods are defined and available
    if (window.geq && window.geq.trackOrder) {
        window.geq.trackOrder({
            order_number: orderNumber,
            order_amount: orderAmount,
            order_email: orderEmail,
        });
    }
}
const useThankYouPage = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const isFreeOrder = useSelector((state) => Number(state.ordersInfo.orderDetails.total_price)) === 0;
    const orderItems = useSelector((state) => state.ordersInfo.orderDetails.items).map((item) => ({
        ...item,
        net_price: `$${Number(item.net_price).toFixed(2)}`,
        gross_price: `$${Number(item.gross_price).toFixed(2)}`,
    }));
    const orderDetails = useSelector((state) => state.ordersInfo.orderDetails);
    const [orderData, setOrderData] = useState(undefined);
    const [trackedOrder, setTrackedOrder] = useState(false);
    const triggerTracking = (data) => {
        executeScriptTwo({
            orderNumber: data.order_id,
            orderAmount: data.usersTotal,
            orderEmail: data.email,
        });
        window.gtag("event", "conversion", {
            send_to: "AW-357048529/oJ2sCKvo3r0CENHBoKoB",
            transaction_id: data.order_id,
        });
    };
    const fetchAllData = async () => {
        window.scrollTo(0, 0);
        dispatch(setGlobalLoading(true));
        const params = new URLSearchParams(search);
        await Promise.all([
            dispatch(LoadOrderDetailsThunk(params.get("from") === "memberperk" && "upcoming_order=1")),
            dispatch(LoadPricingThunk()),
            dispatch(fetchUserAccountThunk()),
            dispatch(LoadRegisteredDietitianThunk()),
        ]);
        if (params.get("from") === "memberperk") {
            await dispatch(LoadNextOrderDatesThunk());
        }
        const data = await apiGetPostPurchaseData();
        triggerTracking(data);
        setOrderData(data);
        dispatch(setGlobalLoading(false));
    };
    useEffect(() => {
        const scriptOneEl = loadScriptOne();
        fetchAllData();
        posthog.capture("$pageview");
        return () => {
            unloadScript(scriptOneEl);
        };
    }, []);
    // this is in its own hook because it should only
    // fire once orderData AND orderItems are available
    useEffect(() => {
        if (!orderData || orderItems.length === 0 || trackedOrder)
            return;
        const properties = {
            eventID: orderData.order_id + "",
            eventName: "Placed Order",
            properties: {
                id: orderData.order_id,
                total_price: orderData.usersTotal,
                total_tax: orderDetails.tax,
                total_shipping: orderDetails.shipping_cost,
                currency: "USD",
                items: orderItems.map((item) => ({
                    product_id: item.sku,
                    name: item.title,
                    price: parseFloat(item.net_price.replace("$", "")),
                    quantity: item.quantity,
                    currency: "USD",
                })),
                // tax_fees: orderData.tax,
                // shipping: orderData.shipping,
                // subtotal: orderData.subtotal,
            },
            profileProperties: {
                $email: orderData.email,
                $is_new_customer: orderData.is_first_order,
            },
            aliases: [`urn:email:${orderData.email}`],
        };
        console.log(properties);
        // debugger;
        cvgForward(properties);
        setTrackedOrder(true);
    }, [orderData, orderItems]);
    return {
        isFreeOrder,
    };
};
export default useThankYouPage;
